<div class="grid lg:grid-cols-1">
  <form [formGroup]="organizationForm" (ngSubmit)="onSubmit()">

    <tr-form-text-input id="name" label="Organization name" [control]="getControl('name')" [minLength]="3" [maxLength]="50"></tr-form-text-input>

    <tr-form-text-input id="slug" label="Slug for public stats page" [control]="getControl('slug')" [minLength]="3"
      [maxLength]="50"></tr-form-text-input>

    <div class="mt-4">
      <label class="block text-sm font-bold mb-2">Game</label>
      <p-autocomplete id="game" formControlName="game" [dropdown]="true" [suggestions]="gameSuggestions" appendTo="body"
        (completeMethod)="searchGames($event)" [autoHighlight]="true" fluid maxlength="50" minlength="3"
        placeholder="What is the primary game played" />

      <div class="input-validation" *ngIf="organizationForm.controls['game'].invalid && organizationForm.controls['game'].touched">
        <div *ngIf="organizationForm.controls['game'].hasError('minlength')">
          At least 3 characters long
        </div>
        <div *ngIf="organizationForm.controls['game'].hasError('maxlength')">
          50 characters max
        </div>
        <div *ngIf="organizationForm.controls['game'].hasError('pattern')">
          Only alphanumeric characters and hyphens allowed.
        </div>
      </div>
    </div>

    <div class="mt-4">
      <label class="block text-sm font-bold mb-2">Locations</label>

      <div class="mb-4">
        <div class="flex flex-wrap gap-4" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="dropLocation($event)">
          <div cdkDrag *ngFor="let location of organizationForm.get('locations')?.value; let i = index">
            <p-chip [label]="location" [removable]="true" (onRemove)="removeLocation(i)"></p-chip>
          </div>
        </div>

        <div *ngIf="organizationForm.get('locations')?.value.length === 0" class="text-slate-400">
          No locations, type in a location and then click the plus or press enter.
        </div>
      </div>

      <p-inputgroup>
        <input pInputText [formControl]="locationName" placeholder="Add a location (click the plus or press enter)" maxlength="40" minlength="3"
          (keydown.enter)="addLocation(locationName.value ?? ''); $event.preventDefault()" />
        <p-inputgroup-addon>
          <p-button icon="bi bi-plus" severity="secondary" (onClick)="addLocation(locationName.value ?? '')" />
        </p-inputgroup-addon>
      </p-inputgroup>

    </div>

    <tr-form-text-input id="description" label="Description" [control]="getControl('description')" [minLength]="0"
      [maxLength]="500"></tr-form-text-input>

    <div class="mt-8 flex justify-between">
      <p-button type="button" severity="secondary" (onClick)="closeDialog()" variant="text">Cancel</p-button>
      <div class="flex gap-2">
        <p-button *ngIf="isEditMode && !showDeleteConfirm" type="button" severity="danger" variant="outlined" icon="bi bi-trash"
          label="Delete Organization" [disabled]="submitting || deleting" (onClick)="startDeleteConfirm()"></p-button>
        <p-button type="submit" icon="bi bi-plus-circle-fill" iconPos="right" [label]="submitting ? 'Saving...' : 'Save'"
          [disabled]="submitting || deleting"></p-button>
      </div>
    </div>

    <div *ngIf="showDeleteConfirm" class="mt-6 border border-red-500 rounded-lg p-4 bg-red-950">
      <p class="text-red-400 font-bold text-sm mb-1">PERMANENT DELETION</p>
      <p class="text-red-300 text-sm mb-4">
        This will permanently delete <strong>everything associated with this organization</strong>.
        <strong>This cannot be undone.</strong> There are no backups made
      </p>
      <div class="mb-3">
        <label class="block text-sm font-bold mb-2 text-red-300">Type <span class="font-mono">DELETE</span> to confirm</label>
        <input pInputText [(ngModel)]="deleteConfirmText" [ngModelOptions]="{standalone: true}" placeholder="DELETE" class="w-full" />
      </div>
      <div class="flex gap-2">
        <p-button type="button" severity="danger" label="Confirm Delete" [disabled]="deleteConfirmText !== 'DELETE' || deleting"
          [label]="deleting ? 'Deleting...' : 'Confirm Delete'" (onClick)="confirmDelete()"></p-button>
        <p-button type="button" severity="secondary" variant="text" label="Cancel" [disabled]="deleting" (onClick)="cancelDelete()"></p-button>
      </div>
    </div>

  </form>

</div>